import { useLang } from "../i18n";
import { colors } from "../theme";
import { whatsappLink } from "../siteConfig";

export default function WhatsAppButton() {
  const { t } = useLang();
  return (
    <a
      href={whatsappLink(t.whatsappDefaultMsg)}
      target="_blank"
      rel="noopener noreferrer"
      style={s.fab}
      className="whatsapp-fab"
      aria-label={t.whatsappFloat}
      title={t.whatsappFloat}
    >
      <svg width="30" height="30" viewBox="0 0 24 24" fill="#ffffff">
        <path d="M12 2.5A9.5 9.5 0 0 0 3.6 17L2.5 21.5l4.6-1.2A9.5 9.5 0 1 0 12 2.5Zm5.5 13.6c-.2.6-1.3 1.2-1.9 1.3-.5.1-1.1.1-1.8-.1-.4-.1-1-.3-1.7-.6-3-1.3-4.9-4.3-5.1-4.5-.1-.2-1.2-1.6-1.2-3.1s.8-2.2 1-2.5c.3-.3.6-.4.8-.4h.6c.2 0 .4 0 .6.5.2.6.7 1.9.8 2.1.1.2.1.4 0 .6-.1.2-.2.4-.4.6-.2.2-.4.5-.6.6-.2.2-.4.4-.2.7.2.3.9 1.4 1.9 2.3 1.3 1.2 2.4 1.5 2.7 1.7.3.2.5.1.7-.1.2-.2.8-.9 1-1.2.2-.3.4-.2.7-.1.3.1 1.8.9 2.1 1 .3.2.5.2.6.3.1.2.1.7-.1 1.3Z" />
      </svg>
    </a>
  );
}

const s = {
  fab: {
    position: "fixed",
    bottom: 26,
    right: 26,
    width: 60,
    height: 60,
    borderRadius: "50%",
    background: colors.whatsapp,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 10px 28px rgba(0,0,0,0.22)",
    zIndex: 150,
  },
};
